import { REFUND_MIN_AMOUNT_IN_POUNDS } from "@/constants/finance"

export default (value: string | null) => {
  if (!value) return "Value must not be empty"

  if (Number(value) < REFUND_MIN_AMOUNT_IN_POUNDS) {
    return `The minimum refund amount is £${REFUND_MIN_AMOUNT_IN_POUNDS}`
  }

  return true
}
